import React, { useMemo } from 'react';
import PropTypes from "prop-types";
import classNames from "classnames";
import { format } from "date-fns";

require('./InputField.scss');

const MULTIDAY_ENTRY_FORMAT = "E' - 'MMM d";

export default function RepeatField({ date, hasError, onBlur, onChange, value }) {
  const className = classNames("col-sm-4 col-xs-6", {
    "has-error": hasError
  });

  const placeholder = useMemo(() => format(date, MULTIDAY_ENTRY_FORMAT), [date]);

  return (
    <div className="row no-margin multiDateRow">
      <div className="col-sm-4 col-xs-6">
        <input
          placeholder={placeholder}
          type="text"
          disabled
          className="disabledField"
        />
      </div>
      <div className={className}>
        <input
          type="number"
          step={0.5}
          min={0}
          max={24}
          placeholder="8.0"
          onBlur={onBlur}
          onChange={onChange}
          value={value}
        />
      </div>
    </div>
  );
}

RepeatField.displayName = "TimeInput.InputTypes.RepeatField";

RepeatField.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  hasError: PropTypes.bool,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/RepeatField.jsx